module.exports = __webpack_public_path__ + "img/NIH.a0179734.png";